var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 17.09a2.99 2.99 0 0 1 2.99 2.99v.4a1.41 1.41 0 0 1-1.01 1.344l-.041.01-.026.011a.892.892 0 0 1-.204.049L10 21.9H3.5c-.776 0-1.4-.632-1.4-1.4v-.41c0-1.658 1.334-3 2.99-3zm7.1-14.444c4.95 1.746 7.544 7.182 5.788 12.14a9.53 9.53 0 0 1-6.792 6.085.9.9 0 0 1-.412-1.752 7.73 7.73 0 0 0 5.508-4.934c1.423-4.02-.679-8.426-4.692-9.842a7.7 7.7 0 0 0-9.841 4.7.9.9 0 0 1-1.698-.597c1.745-4.96 7.18-7.556 12.138-5.8zM8.4 18.89H5.09c-.66 0-1.19.534-1.19 1.2v.011h5.689l-.005-.143a1.19 1.19 0 0 0-1.062-1.062L8.4 18.89zm-1.65-8.3a2.896 2.896 0 0 1 2.884 2.708l.006.182a2.9 2.9 0 0 1-2.561 2.88l-.093.009-.035.01a.914.914 0 0 1-.102.016l-.107.005a2.908 2.908 0 0 1-2.892-2.91c0-1.607 1.293-2.9 2.9-2.9zm5.303-3.72a.9.9 0 0 1 .893.787l.007.113v3.946l3.068 1.865a.9.9 0 0 1 .354 1.137l-.053.1a.9.9 0 0 1-1.137.354l-.1-.053-3.5-2.13a.9.9 0 0 1-.424-.652l-.008-.117V7.77a.9.9 0 0 1 .9-.9zM6.75 12.39c-.613 0-1.1.487-1.1 1.1 0 .532.368.971.868 1.083l.091.015.251-.014c.552-.06.98-.525.98-1.061l-.003-.116A1.089 1.089 0 0 0 6.75 12.39z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPending);
export default __webpack_public_path__ + "static/media/icons-pending.ce2dc8a935a44d9abeeec497ada88f7d.svg";
export { ForwardRef as ReactComponent };